module.exports = __webpack_public_path__ + "img/background.54640d02.png";